// BL598 Phase 1A — `gridctl download [<name>]`.
//
// `download` is the canonical source-fetch verb in the 3-verb collaboration
// model. It is functionally identical to the former `pull`: download the
// source bundle from the last deploy (bytes only — no `cloudgrid.yaml`, no
// link). Both verbs share the same implementation via `makePullLikeCommand`;
// `pull` remains for one release with a deprecation notice. Server-side
// public-download semantics are deferred to BL599 + BL600.

import { Command as CommanderCommand } from 'commander';
import { makePullLikeCommand } from './pull.js';

export const downloadCommand: CommanderCommand = makePullLikeCommand('download');
